/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOrphanedNodes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 2h8v8h-3v1h5v2H7v1h3v8H2v-8h3v-3h6v-1H8V2zm2 2v4h4V4h-4zM4 16v4h4v-4H4zm15.846 2.432 2.225-2.225-1.414-1.414-2.225 2.225-2.225-2.225-1.414 1.414 2.225 2.225-2.225 2.225 1.414 1.414 2.225-2.225 2.225 2.225 1.414-1.414-2.225-2.225z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOrphanedNodes as OrphanedNodes };
